import { render } from "./MStepper.vue?vue&type=template&id=2cdf5b13&scoped=true"
import script from "./MStepper.vue?vue&type=script&lang=js"
export * from "./MStepper.vue?vue&type=script&lang=js"

import "./MStepper.vue?vue&type=style&index=0&id=2cdf5b13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdf5b13"]])

export default __exports__